export default "__VITE_ASSET__8fd93a07__"